import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Clipboard, Icon } from 'mw-style-react';
import { useDispatch } from 'react-redux';
import { prettyPrintJson } from 'pretty-print-json';
import useIntl from 'useIntl';
import './Details.scss';
import { NOTIFY_LEVEL, SHOW_NOTIFY } from 'constants';
import AppUtils from '@control-front-end/utils/utils';
import mes from './intl';

function Details({ transaction }) {
  const preRef = useRef();
  const dispatch = useDispatch();
  const t = useIntl();

  useEffect(() => {
    preRef.current.innerHTML = prettyPrintJson.toHtml(transaction.data);
  }, []);

  return (
    <div styleName="code">
      <pre ref={preRef} styleName="code__pre" />
      <Icon
        type="copy"
        styleName="code__icon"
        onClick={() => {
          Clipboard.copy(JSON.stringify(transaction.data, null, 2));
          dispatch({
            type: SHOW_NOTIFY.REQUEST,
            payload: {
              id: AppUtils.createRid(),
              type: NOTIFY_LEVEL.SUCCESS,
              label: t(mes.trsDetailsCopied),
            },
          });
        }}
      />
    </div>
  );
}

Details.propTypes = {
  transaction: PropTypes.object,
};

export default Details;
